export default __webpack_public_path__ + "static/media/publicitaria.d1892ea0.png";